<button
  mat-flat-button
  class="primary circular-progress-button login-button"
  color="accent"
  type="submit"
  [disabled]="disabled"
  (click)="onloginClick()"
>
  <span *ngIf="!showSpinner">{{ title }}</span>
  <mat-progress-spinner [mode]="spinnerMode" [diameter]="25" *ngIf="showSpinner"></mat-progress-spinner>
</button>
